import i18n from "@/i18n";
const { t } = i18n.global;
export function beforeTime(value, type) {
    if (!value)
        return "";
    const stringValue = value.toString();
    const valDate = new Date(Date.parse(stringValue));
    const now = new Date(Date.now());
    const difference = Math.abs(now.getTime() - valDate.getTime());
    const d = Math.floor(difference / 1000 / 60 / 60 / 24);
    const h = Math.floor(difference / 1000 / 60 / 60 - d * 24);
    const hourHelper = Math.floor(difference / 1000 / 60 / 60);
    const m = Math.floor((difference / 1000 / 60 / 60 - hourHelper) * 60);
    const s = Math.floor(((difference / 1000 / 60 / 60 - hourHelper) * 60 - m) * 60);
    if (type === "short") {
        if (d > 0) {
            if (d == 1) {
                return `${d} ${t("zkratkaden1")}`;
            }
            else {
                return `${d} ${t("zkratkadny")}`;
            }
        }
        else {
            if (h > 0) {
                return `${h} ${t("zkratkah")}`;
            }
            else {
                if (m > 0) {
                    return `${m} ${t("zkratkam")}`;
                }
                else {
                    if (s >= 0) {
                        return `${s} ${t("zkratkas")}`;
                    }
                }
            }
        }
    }
    else {
        return `${d} d ${h} h ${m} m ${s} s`;
    }
}
